import { ListViewProvider, useListView } from '../core/ListViewProvider'
import { QueryRequestProvider } from '../core/QueryRequestProvider'
import { QueryResponseProvider } from '../core/QueryResponseProvider'
import { UsersListHeader } from '../components/header/UsersListHeader'
import { UsersTable } from '../table/UsersTable'
import { UserEditModal } from '../form-edit-modal/CoomonEditModal'
import { KTCard, initialQueryState } from '../../../../../../_metronic/helpers'
import { Card4 } from '../../../../../../_metronic/partials/content/cards/Card4'
import { roleColumns } from './_columns'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useAuth } from '../../../../auth'
import { getUserById } from '../core/_requests'
import { useFetchCommon } from '../../../../../../_metronic/helpers/crud-helper/useQuery'

const DropOffPointList = () => {
  const { responseData: facilityTypeList } = useFetchCommon({
    api: 'users?page=0&size=10&type=PICKUP_POINT',
    label: ['personalDetails', 'name'],
    isDropDown: true,
  })
  const { updateState } = useQueryRequest()

  useEffect(() => {
    if (facilityTypeList && facilityTypeList?.length) {
      updateState({
        enabled: true,
        initialApi: `purchaseOrders?type=SOURCE&pickupPointId=${facilityTypeList[0].value}`,
        ...initialQueryState,
      })
    }
  }, [facilityTypeList])

  const searchElements = [
    {
      type: 'select',
      value: 'select',
      options: [...facilityTypeList],
    },
  ]
  return (
    <KTCard>
      <UsersListHeader
        showDownload
        // showResetButton={true}
        searchElements={searchElements}
        placeholder='Search Category'
      />
      {/* Metrics Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '20px', padding: '10px 30px' }}>

        {/* Card 1 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 11C14.7614 11 17 8.76142 17 6C17 3.23858 14.7614 1 12 1C9.23858 1 7 3.23858 7 6C7 8.76142 9.23858 11 12 11Z" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M2 22C2 17.5817 6.47715 14 12 14C17.5228 14 22 17.5817 22 22" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Total Plastic Keepers</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>128</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>All time</div>
          </div>
        </div>

        {/* Card 2 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M6 18L18 6" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Active Keepers</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>96</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>75% of total</div>
          </div>
        </div>

        {/* Card 3 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#FFE500', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 6V12L16 14" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Inactive Keepers</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>32</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>25% of total</div>
          </div>
        </div>

        {/* Card 4 */}
        <div style={{ backgroundColor: '#ffffff', borderRadius: '12px', padding: '16px', display: 'flex', alignItems: 'center', gap: '16px', border: '1px solid #F0F1F3', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.02)' }}>
          <div style={{ backgroundColor: '#000000', width: '56px', height: '56px', borderRadius: '12px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexShrink: 0 }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="3" y="8" width="18" height="13" rx="2" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 8V21" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M12 8V5C12 3.89543 11.1046 3 10 3C8.89543 3 8 3.89543 8 5C8 6.65685 9.34315 8 11 8H12ZM12 8V5C12 3.89543 12.8954 3 14 3C15.1046 3 16 3.89543 16 5C16 6.65685 14.6569 8 13 8H12Z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <div>
            <div style={{ color: '#000000', fontSize: '12px', fontWeight: '600', marginBottom: '6px' }}>Rewards Claimed</div>
            <div style={{ color: '#000000', fontSize: '22px', fontWeight: '700', lineHeight: '1' }}>248</div>
            <div style={{ color: '#7E8299', fontSize: '12px', marginTop: '6px' }}>This month</div>
          </div>
        </div>

      </div>
      <UsersTable columnProps={roleColumns} />
      {/* <UserEditModal showViewPage getByIdApi='return/orders/' formName='ReturnOrdersModalForm' /> */}
    </KTCard>
  )
}

const PurchaseOrdersWrapper = () => (
  <QueryRequestProvider initialValue={{ enabled: false }}>
    <QueryResponseProvider>
      <ListViewProvider>
        <DropOffPointList />
      </ListViewProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)

export { PurchaseOrdersWrapper }
